import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [

    { state: 'collis\/retrait', type: 'link', name: 'retraitcollis', icon: 'remove_from_queue' , priv: 'rd_retrait', children: []},
    { state: 'searchcolis', type: 'link', name: 'recherchecolis', icon: 'remove_from_queue' , priv: 'rd_retrait', children: []},
    { state: 'listbordeaureau\/externe', type: 'link', name: 'listbordeaureau', icon: 'pending_actions' , priv: 'rd_bordereauext', children: []},
    { state: 'session\/usersession', type: 'link', name: 'raportsessions', icon: 'insights' , priv: 'rd_retrait', children: []}

];

@Injectable()
export class  MenuItemsRetrait {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
